/* Bruno's Choice - Produktseite (ausgelagert aus sections/main-product-tipaw.liquid).
   Findet alle PDP-Instanzen ueber die Root-ID und leitet die Section-ID daraus ab. */
(function () {
  function init(root) {
    var pid = root.id.slice('TipawPDP-'.length);
    var byId = function (prefix) { return document.getElementById(prefix + '-' + pid); };

    /* Tabs */
    var tabs = root.querySelectorAll('.tipaw-tabs__nav button');
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabs.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        root.querySelectorAll('.tipaw-tabs__panel').forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.panel === btn.dataset.tab);
        });
      });
    });

    /* Thumbnails */
    var mainImg = byId('TipawMainImg');
    var thumbs = byId('TipawThumbs');
    if (mainImg && thumbs) {
      thumbs.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          thumbs.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          mainImg.src = btn.dataset.full;
          mainImg.parentElement.classList.toggle('is-pack', btn === thumbs.querySelector('button'));
        });
      });
    }

    /* Groessenwahl -> Dosierungs-Hinweis */
    var sizes = byId('TipawSizes');
    var doseEl = byId('TipawDose');
    if (sizes && doseEl) {
      sizes.querySelectorAll('.tipaw-size').forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizes.querySelectorAll('.tipaw-size').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          doseEl.textContent = btn.dataset.dose;
        });
      });
    }

    /* Varianten-Karten -> Formular + CTA-Preis + Sticky-Preis */
    var hiddenId = byId('TipawVariantId');
    var ctaPrice = root.querySelector('[data-cta-price]');
    var sticky = byId('TipawSticky');
    var stickyPrice = sticky ? sticky.querySelector('[data-sticky-price]') : null;
    root.querySelectorAll('.tipaw-offer[data-variant]').forEach(function (card) {
      card.addEventListener('click', function () {
        root.querySelectorAll('.tipaw-offer[data-variant]').forEach(function (c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');
        var input = card.querySelector('input');
        if (input) input.checked = true;
        if (hiddenId) hiddenId.value = card.dataset.variant;
        if (ctaPrice) ctaPrice.textContent = card.dataset.price;
        if (stickyPrice) stickyPrice.textContent = card.dataset.price;

        /* Galerie auf das gewaehlte Set umschalten. data-pack-img steht nur an
           Karten, fuer die ein freigestelltes Packungsbild hinterlegt ist. */
        if (mainImg && card.dataset.packImg) {
          mainImg.src = card.dataset.packImg;
          mainImg.alt = card.querySelector('.tipaw-offer__title')
            ? card.querySelector('.tipaw-offer__title').textContent.trim()
            : mainImg.alt;
          if (thumbs) {
            thumbs.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
          }
        }
      });
    });

    /* Sticky-Kaufleiste: einblenden, sobald der Haupt-CTA aus dem Bild gescrollt ist */
    var ctaBtn = byId('TipawCTA');
    if (sticky && ctaBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var passed = en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !en.isIntersecting && passed);
      }, { threshold: 0 });
      io.observe(ctaBtn);
    }
  }

  function boot() {
    document.querySelectorAll('.tipaw-pdp[id^="TipawPDP-"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Theme-Editor: Section wird nach Aenderungen neu gerendert */
  document.addEventListener('shopify:section:load', boot);
})();
